export interface MeliState {
  meliToken: string;
  productsCount: number;
}

export const initialState: MeliState = {
  meliToken: "",
  productsCount: 0,
};
